export const roundToNearestHalfHour = (from) => {
  const startOfHour = new Date(from * 1000)
  startOfHour.setMinutes(0, 0, 0)
  let processedFrom = Math.floor(startOfHour.getTime() / 1000)
  if (from - processedFrom >= 1800) {
    processedFrom += 1800
  }
  return processedFrom
}

export const formatTime = (seconds, guide) => {
  if (guide === void 0) {
    guide = seconds
  }
  seconds = seconds < 0 ? 0 : seconds
  let s = Math.floor(seconds % 60);
  let m = Math.floor(seconds / 60 % 60);
  let h = Math.floor(seconds / 3600);
  const gm = Math.floor(guide / 60 % 60);
  const gh = Math.floor(guide / 3600); // handle invalid times

  if (isNaN(seconds) || seconds === Infinity) {
    // '-' is false for all relational operators (e.g. <, >=) so this setting
    // will add the minimum number of fields specified by the guide
    h = m = s = '-';
  }

  // Check if we need to show hours.
  // If hours are showing, we may need to add a leading zero.
  h = h > 0 || gh > 0 ? h + ':' : '';

  // Always show at least one digit of minutes.
  m = ((h || gm >= 10) && m < 10 ? '0' + m : m) + ':';

  // Check if leading zero is need for seconds.
  s = s < 10 ? '0' + s : s;

  return h + m + s;
}

export const formatTimeHumanReadable = (seconds) => {
  seconds = seconds < 0 ? 0 : seconds

  let s = Math.floor(seconds % 60);
  let m = Math.floor(seconds / 60 % 60);
  let h = Math.floor(seconds / 3600);

  if (isNaN(seconds) || seconds === Infinity) {
    return ''
  }

  let result = h > 0 ? h + 'h ' : ' '
  result += m > 0 ? '' + m + 'min' : ''

  if (h === 0) {
    result += s > 0 ? ' ' + s + 'sec' : ''
  }

  return result;
}

export const formatDateHumanReadable = (timestamp) => {

  var ts= new Date(timestamp * 1000);

  var options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
  return ts.toLocaleDateString('en-US', options);
  
}
export const formatCustomHumanReadable = (timestamp) => {

  var ts= new Date(timestamp * 1000);

  var options = {  year: 'numeric', month: 'short', day: 'numeric', hour:'2-digit', minute: '2-digit'};
  return ts.toLocaleDateString('en-US', options);
  
}